import MESSAGES from 'core/data-model/constants/bi-messages'
import { paymentChannelsSubSectionOrdinary } from '../../common/sections/payment-channels-sub-section-ordinary'

export const _paymentChannelsSection = async (basicPlan) => {
  const paymentChannels = await paymentChannelsSubSectionOrdinary(basicPlan)
  return {
    stack: [
      {
        text: MESSAGES.PAYMENT_CHANNELS,
        style: 'title',
        marginTop: -6,
        pageBreak: 'before',
      },
      ...paymentChannels,
    ],
  }
}
export const paymentChannelsSection = async (basicPlan) => {
  return _paymentChannelsSection(basicPlan)
}
